export const handleDateFormat = (date: string) => {
  const [year, month, day] = date.split('-');
  const formattedDate = `${day}/${month}/${year}`;
  return formattedDate;
};
